export function getInnerHeight() {
  return window.innerHeight;
}



// WEBPACK FOOTER //
// ./src/common/pageUtils.js